import PrescriptionsHistoryContainer from './prescriptions-history-container';

export default PrescriptionsHistoryContainer;
